import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const DuplicateDetectionWarning = ({ 
  duplicateReports, 
  onViewExisting, 
  onContinueAnyway, 
  onCancel,
  className = '' 
}) => {
  if (!duplicateReports || duplicateReports?.length === 0) {
    return null;
  }

  return (
    <div className={`bg-warning/10 border border-warning/20 rounded-lg p-4 ${className}`}>
      <div className="flex items-start space-x-3">
        <Icon name="AlertTriangle" size={20} className="text-warning flex-shrink-0 mt-0.5" />
        
        <div className="flex-1 space-y-3">
          <div>
            <h3 className="text-sm font-semibold text-foreground">Similar Reports Found</h3>
            <p className="text-sm text-muted-foreground mt-1">
              We found {duplicateReports?.length} similar report{duplicateReports?.length > 1 ? 's' : ''} for this service. 
              Consider confirming an existing report instead of creating a duplicate.
            </p>
          </div>

          {/* Existing Reports */}
          <div className="space-y-2">
            {duplicateReports?.slice(0, 3)?.map((report) => (
              <div key={report?.id} className="flex items-center justify-between p-3 bg-card border border-border rounded-md">
                <div className="flex-1">
                  <p className="text-sm font-medium text-foreground">
                    {report?.provider} - {report?.severity} Issue
                  </p>
                  <p className="text-xs text-muted-foreground">
                    Reported {report?.timeAgo} • {report?.confirmations} confirmations
                  </p>
                </div>
                
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onViewExisting(report?.id)}
                  iconName="ExternalLink"
                  iconPosition="right"
                >
                  View
                </Button>
              </div>
            ))}
            
            {duplicateReports?.length > 3 && (
              <p className="text-xs text-muted-foreground text-center">
                +{duplicateReports?.length - 3} more similar reports
              </p>
            )}
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-2">
            <Button
              variant="outline"
              onClick={onViewExisting}
              iconName="Search"
              iconPosition="left"
              className="flex-1"
            >
              View All Similar Reports
            </Button>
            
            <Button
              variant="secondary"
              onClick={onContinueAnyway}
              iconName="Plus"
              iconPosition="left"
              className="flex-1"
            >
              Continue with New Report
            </Button>
            
            <Button
              variant="ghost"
              onClick={onCancel}
              iconName="X"
              iconPosition="left"
              className="flex-1 sm:flex-none"
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DuplicateDetectionWarning;